import { Form, Spinner } from "react-bootstrap";
import { useState, useContext, useEffect } from "react";
import SmsForm from "./SmsForm";
import EmailForm from "./EmailForm";
import UrlForm from "./UrlForm";
import WhatsappForm from "./WhatsappForm";
import { TicketContext } from "../../store/ticket-context";
import { DomainDataContext } from "../../store/domaindata-context";
import useHttp from "../../hooks/use-http";
import AuthContext from "../../store/auth-context";
import "./Invite.css";
import { useParams, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import zafClient from "../../zafclient";

const InivteTab = (props) => {
  console.warn(window.origininfo);

  let { teamid } = useParams();
  console.error(teamid);
  const navigate = useNavigate();
  const [key, setKey] = useState("1");
  const [enteredSmsPhone, setenteredSmsPhone] = useState(false);
  const [enteredWhatsappPhone, setenteredWhatsappPhone] = useState(false);
  const [enteredEmail, setenteredEmail] = useState(false);
  const [selectedTeam, setselectedTeam] = useState(false);
  const [sessionData, setsessionData] = useState(false);
  const [validated, setValidated] = useState("");

  const [isInvitingLoading, setisInvitingLoading] = useState(false);

  const { isLoading, error, sendRequest } = useHttp();

  const authCtx = useContext(AuthContext);
  const ticket = useContext(TicketContext);
  const domainData = useContext(DomainDataContext);
  useEffect(() => {
    if (domainData !== null) {
      if (domainData.data) {
        console.error(domainData.data.TEAMS);
        domainData.data.TEAMS.map((team) => {
          if (team.TEAMID == teamid) {
            setselectedTeam(team);
            onTabchange(team.SHOWMECONFIGS.DEFAULTINVITETYPE);
          }
        });
      }
    }
  }, [domainData]);
  const onTabchange = (k) => {
    setKey(String(k));
    setValidated("");
  };

  const sendInputValueSMS = (val) => {
    setenteredSmsPhone(val);
  };
  const sendInputValueWhatsapp = (val) => {
    setenteredWhatsappPhone(val);
  };
  const sendInputValueEmail = (val) => {
    setenteredEmail(val);
  };
  const setTeamID = (val) => {
    setselectedTeam(val);
    console.error(val);
    onTabchange(val.SHOWMECONFIGS.DEFAULTINVITETYPE);
  };

  let agentURL = false;

  // Once session invite is done
  const onInviteDone = (data) => {
    setisInvitingLoading(false);
    const isSuccess = data && !data.errorStatus && !data.error;
    if (isSuccess) {
      if (+key !== 7) {
        zafClient.invoke("notify", "Invitation sent");
      }
      console.error("from invite session");
      console.error(data);
      if (agentURL) {
        window.open(
          agentURL +
            "&platform=Zendesk&redirect_url=" +
            window.origininfo.origin +
            "/agent/tickets/" +
            ticket.id,
          "_blank"
        );
      }
    } else {
      const errorMsg =
        (data && data.error && data.error.message) ||
        (data && data.message) ||
        "Failed to send invitation";
      zafClient.invoke("notify", errorMsg, "error");
    }
  };

  // After session details fetched: store URLs, then either notify (URL tab)
  // or send invitation (SMS/WhatsApp/Email). agentUrl, guestUrl and smsTemplate
  // come from the GET /sessions/{id} response — POST /sessions only returns
  // sessionId on the new API.
  const onSessionDetails = (details, sessionId) => {
    const guestUrl = (details && details.guestUrl) || "";
    const agentUrl = (details && details.agentUrl) || "";
    const smsTemplate = (details && details.smsTemplate) || "";

    agentURL = agentUrl;
    setsessionData({
      sessionID: sessionId,
      guestURL: guestUrl,
    });

    if (+key === 7) {
      zafClient.invoke("notify", "Session Created");
      onInviteDone(details);
      return;
    }

    console.error("from create session");
    console.error(details);

    let request = {
      url: guestUrl,
      invitationType: parseInt(key),
    };
    // intl-tel-input emits standard ISO "gb" for British, but the Blitzz
    // API expects "UK". Convert before sending.
    const toBlitzzIso = (iso) => {
      const upper = (iso || "").toUpperCase();
      return upper === "GB" ? "UK" : upper;
    };
    switch (parseInt(key)) {
      case 1:
        request["mobileNo"] = enteredSmsPhone.phone.replace(/[^\d]/g, "");
        request["message"] = smsTemplate;
        request["countryCode"] = (enteredSmsPhone.country || "").replace("+", "");
        request["isoCode"] = toBlitzzIso(enteredSmsPhone.isocode);
        break;
      case 2:
        request["mobileNo"] = enteredWhatsappPhone.phone.replace(/[^\d]/g, "");
        request["message"] = "";
        request["countryCode"] = (enteredWhatsappPhone.country || "").replace("+", "");
        request["isoCode"] = toBlitzzIso(enteredWhatsappPhone.isocode);
        break;
      case 3:
        request["emailAddress"] = enteredEmail;
        request["message"] = smsTemplate;
        break;
    }
    console.error(request);
    sendRequest(
      {
        url: "sessions/" + sessionId + "/invitations",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + authCtx.token,
          usertoken: authCtx.token,
        },
        body: request,
      },
      onInviteDone
    );
  };

  // After POST /sessions: extract sessionId, then fetch session details to
  // get agentUrl/guestUrl/smsTemplate (new API flow — values are not on the
  // POST response).
  const onCreateSession = (data) => {
    const sessionId = data && data.sessionId;
    if (!sessionId) {
      domainData.hasError = true;
      domainData.isLoading = false;
      domainData.message = data.message;
      setisInvitingLoading(false);
      zafClient.invoke("notify", data.message, "error");
      return;
    }
    sendRequest(
      {
        url: "sessions/" + sessionId,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + authCtx.token,
          usertoken: authCtx.token,
        },
      },
      (details) => onSessionDetails(details, sessionId)
    );
  };

  // Create Session
  const handleSubmit = (event) => {
    setValidated("");
    console.log(enteredSmsPhone.phone);
    event.preventDefault();

    if (key == 1 && !enteredSmsPhone.isValidnumber) {
      if (!window.smsiti.isValidNumber()) {
        event.stopPropagation();
        setValidated("Please enter valid phone number");
        return;
      }
    } else if (key == 2 && enteredWhatsappPhone.isValidnumber) {
      if (!window.Whatsappiti.isValidNumber()) {
        event.stopPropagation();
        setValidated("Please enter valid phone number");
        return;
      }
    } else if (key == 3) {
      if (enteredEmail.trim() == "") {
        event.stopPropagation();
        setValidated("Please enter valid email address");
        return;
      }

      var emailPattern = /^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,8}$/;
      if (!emailPattern.test(enteredEmail.trim())) {
        event.stopPropagation();
        setValidated("Please enter valid email address");
        return;
      }
    }

    setValidated(true);
    setisInvitingLoading(true);

    let request = {
      sessionType: 1,
      reference: ticket && ticket.id != null ? String(ticket.id) : "",
      collaborationProfileId: selectedTeam.TEAMID,
      from: 2, // Send this key to identify from where session was created
    };

    sendRequest(
      {
        url: "sessions",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + authCtx.token,
          usertoken: authCtx.token,
        },
        body: request,
      },
      onCreateSession
    );
  };

  // Available invite types — WhatsApp gated by team config, matching the
  // previous react-bootstrap Tabs render.
  const showWhatsapp =
    selectedTeam && selectedTeam.SHOWMECONFIGS &&
    selectedTeam.SHOWMECONFIGS.WHATSAPPINVITE == "1";
  const TYPES = [
    { k: "1", label: "SMS" },
    ...(showWhatsapp ? [{ k: "2", label: "WhatsApp" }] : []),
    { k: "3", label: "Email" },
    { k: "7", label: "URL" },
  ];

  const showBack = domainData && domainData.data && domainData.data.TEAMS && domainData.data.TEAMS.length > 1;

  return (
    <div className="invite-shell">
      <Form onSubmit={handleSubmit}>
        <div className="invite-type-tabs" role="tablist">
          {TYPES.map((t) => (
            <button
              key={t.k}
              type="button"
              role="tab"
              className={"invite-type-tab" + (key === t.k ? " active" : "")}
              onClick={() => onTabchange(t.k)}
            >
              {t.label}
            </button>
          ))}
        </div>

        {/* Mount every pane so each form's state and any window globals it
            initialises (window.smsiti / window.Whatsappiti via intl-tel-input)
            survive tab switches — matches the prior react-bootstrap Tabs
            default of keeping inactive panes mounted but hidden. The
            .invite-pane.active class triggers a short fade-in keyframe so
            switching SMS ↔ WhatsApp gives a visible cue (their layouts are
            otherwise identical). */}
        <div className={"invite-pane" + (key === "1" ? " active" : "")}>
          <SmsForm sendSMSnumber={sendInputValueSMS} />
        </div>
        {showWhatsapp && (
          <div className={"invite-pane" + (key === "2" ? " active" : "")}>
            <WhatsappForm sendWhatsappnumber={sendInputValueWhatsapp} />
          </div>
        )}
        <div className={"invite-pane" + (key === "3" ? " active" : "")}>
          <EmailForm sendEmail={sendInputValueEmail} />
        </div>
        <div className={"invite-pane" + (key === "7" ? " active" : "")}>
          <UrlForm sessionData={sessionData} />
        </div>

        {typeof validated === "string" && validated.length > 1 && (
          <div className="invite-error">{validated}</div>
        )}

        {/* Footer layout: Back link in a fixed-width slot on the left, primary
            button centered in the remaining space, mirror spacer on the right
            of equal width — keeps the primary button visually centered as the
            sidebar width changes and whether or not Back is rendered. */}
        <div className="invite-actions">
          <div className="invite-back-slot">
            {showBack && (
              <button
                type="button"
                className="invite-back-link"
                onClick={() => navigate("/invite")}
              >
                <FontAwesomeIcon icon={faAngleLeft} /> Back
              </button>
            )}
          </div>
          <div className="invite-actions-center">
            <button
              type="submit"
              className="invite-primary-btn"
              disabled={isInvitingLoading}
              onClick={!isInvitingLoading ? props.handleClick : null}
            >
              {isInvitingLoading && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              {key === "7"
                ? isInvitingLoading
                  ? "Creating session"
                  : "Create new session"
                : isInvitingLoading
                ? "Creating session"
                : "Invite & Join"}
            </button>
          </div>
          <div className="invite-actions-mirror" aria-hidden="true" />
        </div>
      </Form>
    </div>
  );
};

export default InivteTab;
